// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StudentReg__menu___3NmLT {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    background-color: var(--bg-color);\n}\n\n.StudentReg__confirmation-code___NC8fR,\n.StudentReg__confirmation-code___NC8fR:focus {\n    border-width: 1px;\n    border-color: red;\n}\n", ""]);
// Exports
exports.locals = {
	"menu": "StudentReg__menu___3NmLT",
	"confirmation-code": "StudentReg__confirmation-code___NC8fR"
};
module.exports = exports;
